const Main = (props) => <div>{props.children}</div>;

export default Main;
